import { render, staticRenderFns } from "./LeftDrawer.vue?vue&type=template&id=25b8eaf6&scoped=true&"
import script from "./LeftDrawer.vue?vue&type=script&lang=js&"
export * from "./LeftDrawer.vue?vue&type=script&lang=js&"
import style0 from "./LeftDrawer.vue?vue&type=style&index=0&id=25b8eaf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8eaf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
